import { Link } from "react-router-dom";

export const Mark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path
      d="M32 8 L46 30 L36 30 L36 46 C36 52 31 56 25 56 C20 56 17 53 16 49 L22 47 C23 49 24 50 25.5 50 C28 50 30 48.5 30 46 L30 30 L18 30 Z"
      fill="currentColor"
    />
  </svg>
);

export const Logo = () => (
  <Link to="/" data-testid="nav-logo-link" className="group flex items-center gap-2.5">
    <span className="text-ember transition-transform duration-500 group-hover:-translate-y-0.5 group-hover:rotate-[8deg]">
      <Mark className="h-7 w-7" />
    </span>
    <span className="font-display text-[15px] font-extrabold uppercase tracking-[0.18em]">Spear</span>
  </Link>
);
